<div class="header-margin"></div>
<goa-banner>
  <div caption>Court Case Management Digital Service</div>
  <div subcaption>Redirect Help</div>
</goa-banner>
<div class="center">
  <div>
    <div><mat-icon class="mat-icon-big">warning_amber</mat-icon></div>
    <div>We have moved</div>
    <div>Please visit us at our new URL and update your bookmarks</div>
    <div>
      <a
        mat-flat-button
        href="{{ redirectUri$ | async }}{{ routePath }}"
        target="_blank"
      >
        {{ redirectUri$ | async }}{{ routePath }}
      </a>
    </div>
  </div>
</div>
